import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '@/components/base/combobox'
import { WarehouseLocationSelectorQuery } from './__generated__/selector_query'
import { Query } from './selector_query'
import { useCombobox } from '@/helpers/useCombobox'

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
  warehouseId: string
}

export const Selector = ({ value, onChange, invalid, warehouseId }: Props) => {
  const { data, loading } = useQuery<WarehouseLocationSelectorQuery>(
    Query,
    { variables: { id: warehouseId } }
  )

  const { items } = useCombobox<string>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: data?.warehouses.nodes[0].locations,
    buildSearchable: item => ({
      id: item,
      name: item
    })
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={loading}
      moreToFetch={false}
      refetch={() => {}}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      allowCustomInput
      onChange={onChange}
    />
  )
}
